import { render } from "./Scope.vue?vue&type=template&id=2fd6805e"
import script from "./Scope.vue?vue&type=script&lang=js"
export * from "./Scope.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__